import { $api } from "@/kibi/core/utils/api";
import type { InjectionKey } from "vue";
import type {
  CreateVendorRequest,
  UpdateVendorRequest,
  Vendor,
} from "../../domain/entities/vendor";

export interface VendorDataSource {
  getVendors(): Promise<Vendor[]>;
  getVendor(id: string): Promise<Vendor>;
  createVendor(request: CreateVendorRequest): Promise<Vendor>;
  updateVendor(id: string, request: UpdateVendorRequest): Promise<Vendor>;
  deleteVendor(id: string): Promise<void>;
}

export const vendorDataSourceKey: InjectionKey<VendorDataSource> =
  Symbol("VendorDataSource");

export class VendorDataSourceImpl implements VendorDataSource {
  async getVendors(): Promise<Vendor[]> {
    const response = await $api<{ data: Vendor[] }>("/products/vendors", {
      method: "GET",
    });
    return response.data;
  }

  async getVendor(id: string): Promise<Vendor> {
    const response = await $api<{ data: Vendor }>(`/products/vendors/${id}`, {
      method: "GET",
    });
    return response.data;
  }

  async createVendor(request: CreateVendorRequest): Promise<Vendor> {
    const response = await $api<{ data: Vendor }>("/products/vendors", {
      method: "POST",
      body: request,
    });
    return response.data;
  }

  async updateVendor(
    id: string,
    request: UpdateVendorRequest,
  ): Promise<Vendor> {
    const response = await $api<{ data: Vendor }>(`/products/vendors/${id}`, {
      method: "PUT",
      body: request,
    });
    return response.data;
  }

  async deleteVendor(id: string): Promise<void> {
    await $api(`/products/vendors/${id}`, {
      method: "DELETE",
    });
  }
}
